import { LuneTheme, useDevice } from '@lune-fe/lune-ui-lib'
import Box from '@mui/material/Box'
import Text from '@mui/material/Typography'
import Astrazeneca from '@public/images/logos/astrazeneca.png'
import Forto from '@public/images/logos/forto.png'
import Jas from '@public/images/logos/jas.svg'
import Logwin from '@public/images/logos/logwin.png'
import Magaya from '@public/images/logos/magaya.png'
import Mahle from '@public/images/logos/mahle.png'
import Pmi from '@public/images/logos/pmi.png'
import Puma from '@public/images/logos/puma.png'
import Rohlig from '@public/images/logos/rohlig.png'
import Visa from '@public/images/logos/visa.png'
import { FC } from 'react'

import LogosGrid from '@/components/LogosGrid'

const logos = [
    {
        name: 'Visa',
        img: Visa,
        width: 52.45,
        height: 17,
    },
    {
        name: 'PUMA',
        img: Puma,
        width: 78,
        height: 41.48,
    },
    {
        name: 'AstraZeneca',
        img: Astrazeneca,
        width: 148,
        height: 37,
    },
    {
        name: 'Philip Morris International',
        img: Pmi,
        width: 156,
        height: 35.73,
    },
    {
        name: 'MAHLE',
        img: Mahle,
        width: 102,
        height: 23.31,
    },
]
const logos2 = [
    {
        name: 'Jas',
        img: Jas,
        width: 83.72,
        height: 32,
    },
    {
        name: 'Rohlig',
        img: Rohlig,
        width: 104,
        height: 26.1,
    },
    {
        name: 'Logwin',
        img: Logwin,
        width: 134,
        height: 13,
    },
    {
        name: 'Forto',
        img: Forto,
        width: 77.68,
        height: 19,
    },
    {
        name: 'Magaya',
        img: Magaya,
        width: 125.5,
        height: 25,
    },
]

const HomepageLogos: FC<{ removeBorder?: boolean; caption?: string }> = ({
    removeBorder,
    caption,
}) => {
    const { smScreen } = useDevice()
    const { palette } = LuneTheme
    return (
        <Box
            sx={{
                position: 'relative',
                ...(!removeBorder && {
                    '&:after': {
                        content: '""',
                        position: 'absolute',
                        bottom: 0,
                        left: '-50%',
                        right: '-50%',
                        height: '1px',
                        backgroundColor: `${palette.Grey300}`,
                        mx: {
                            lg: 37,
                            xl: 37,
                        },
                    },
                }),
            }}
        >
            {caption ? (
                <Text variant={'body2'} sx={{ textAlign: 'center', pt: 6, color: palette.Grey900 }}>
                    {caption}
                </Text>
            ) : null}
            {!smScreen ? (
                <>
                    <LogosGrid sx={{ height: '120px', lineHeight: '120px' }} logos={logos} />
                    <LogosGrid
                        sx={{ height: '120px', lineHeight: '120px', marginTop: '-48px' }}
                        logos={logos2}
                    />
                </>
            ) : (
                <LogosGrid
                    variant="grid"
                    hiddenOnSmIndices={[9]}
                    logos={[...logos, ...logos2]}
                    sx={{ py: 5 }}
                />
            )}
        </Box>
    )
}

export default HomepageLogos
